import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";

const firebaseConfig = {
  apiKey: "AIzaSyAJoCZ817dXilvfO1Rm3oDRT_BtKdafFCM",
  authDomain: "cultiq-e1114.firebaseapp.com",
  projectId: "cultiq-e1114",
  storageBucket: "cultiq-e1114.firebasestorage.app",
  messagingSenderId: "526652382796",
  appId: "1:526652382796:web:6cb419a98f6a45dec69ee9",
  measurementId: "G-20J2Z5D440",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

const ai = getAI(app, { backend: new GoogleAIBackend() });
export const gemini = getGenerativeModel(ai, {
  model: "gemini-2.0-flash",
  systemInstruction: "あなたは世界の文化・ビジネスマナー・生活習慣の専門家AIアシスタントです。日本語で簡潔に（250字以内）、実用的なアドバイスを提供してください。",
});
